import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Layout
import NotFound from "../pages/NotFound.jsx";
import AppLayout from "../components/header.jsx";

// Pages
import AuthPage from "../pages/LoginPage.jsx";
import MpinSetupPage from "../pages/MpinPage.jsx";
import MpinResetPage from "../pages/resetMpin.jsx";
import AttendanceHistory from "../pages/AttendanceHistory.jsx";
import AttendanceLog from "../pages/AttendanceLogPage.jsx";
import Dashboard from "../pages/Dashboard.jsx";
import ProfilePage from "../pages/ProfilePage.jsx";
import DocumentsPage from "../pages/DocumentsPage.jsx";
import Mytrip from "../pages/MyTripDetails.jsx";
import DmrPage from "../pages/DmrPage.jsx";
import DmrHistory from "../pages/DmrHistory.jsx";
import StartTrip from "../pages/StartTrip.jsx";
import Driveractivity from "../pages/DriverActivity.jsx";
import OtherExpense from "../pages/OtherExpense.jsx";
import OtherExpHistory from "../pages/OtherExpenseHistory.jsx";
import RefuelPage from "../pages/RefuelPage.jsx";
import RefuelHistoryPage from '../pages/RefuelHistoryPage.jsx';
import ContactOfficePage from "../pages/ContactOfficePage.jsx";
import SendLocationPage from "../pages/SendLocationPage.jsx";

// Components
import TripActionsHub from "../pages/ActionsHub.jsx";
import PrivateRoute from "../components/PrivateRoute.jsx";

const AppRoutes = () => {
  const handleLogout = () => {
    localStorage.removeItem("driverToken");
    localStorage.removeItem("driverRegNo");
    window.location.href = "/login";
  };

  return (
    <Routes>
      {/* ---------- PUBLIC ROUTES ---------- */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<AuthPage />} />
      <Route path="/mpin-login" element={<AuthPage />} />

      {/* ---------- PROTECTED ROUTES (NO LAYOUT) ---------- */}
      <Route
        path="/setup-mpin"
        element={
          <PrivateRoute>
            <MpinSetupPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/reset-mpin"
        element={
          <PrivateRoute>
            <MpinResetPage />
          </PrivateRoute>
        }
      />

      {/* ---------- PROTECTED ROUTES WITH LAYOUT ---------- */}
      <Route
        element={
          <PrivateRoute>
            <AppLayout handleLogout={handleLogout} />
          </PrivateRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/attendance-history" element={<AttendanceHistory />} />
        <Route
          path="/attendance-log/:date/:month/:year"
          element={<AttendanceLog />}
        />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/documents" element={<DocumentsPage />} />
        <Route path="/my-trips/:id" element={<Mytrip />} />
        <Route path="/dmr" element={<DmrPage />} />
        <Route path="/dmr-history/:id" element={<DmrHistory />} />
        <Route path="/start-trip/:enq_id" element={<StartTrip />} />
        <Route path="/driver-activity" element={<Driveractivity />} />
        <Route path="/actions-hub" element={<TripActionsHub />} />
        <Route path="/other-expense" element={<OtherExpense />} />
        <Route path="/otherexp-history" element={<OtherExpHistory />} />
        <Route path="/refuel" element={<RefuelPage />} />
        <Route path="/refuel-history" element={<RefuelHistoryPage />} />
        <Route path="/contact-office" element={<ContactOfficePage />} />
        <Route path="/send-location" element={<SendLocationPage />} />

        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="*" element={<NotFound />} />

      {/* ---------- 404 ---------- */}
      {/* <Route
        path="*"
        element={<h1 style={notFoundStyle}>404 - Page Not Found</h1>}
      /> */}
    </Routes>
  );
};

// const notFoundStyle = {
//   textAlign: "center",
//   marginTop: "50px",
//   color: "white",
//   fontFamily: "Inter, sans-serif",
// };

export default AppRoutes;
